import React from 'react'
import PropTypes from 'prop-types'
import ReactImgix from 'react-imgix'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import styles from './banner.css'
import { segmentTrackClickContentCard } from '../../segment/segment-track'

const transitionInterval = 4000

class Banner extends React.PureComponent {
  // eslint-disable-next-line no-undef
  state = { topImageFadeIn: true }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState(state => ({ topImageFadeIn: !state.topImageFadeIn }))
    }, transitionInterval)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  onClickHandler() {
    const { content: { contentItem, title } } = this.props
    segmentTrackClickContentCard(contentItem, null, `Banner ${title}`, window.location.pathname)
  }

  render() {
    const { content } = this.props
    const { topImageFadeIn } = this.state

    const isPortrait = window.innerHeight / window.innerWidth > 1
    const image = isPortrait ? content.mobile : content.desktop

    const imageSharedProps = {
      type: 'img',
      width: Math.ceil(window.innerWidth / 100) * 100,
      imgixParams: { fit: 'clip' }
    }

    const getImages = () => {
      return (
        <>
          <ReactImgix
            className={classnames(styles.image, styles.topImage, {
              [styles.fadedIn]: topImageFadeIn
            })}
            src={image[0]}
            {...imageSharedProps}
          />
          <ReactImgix
            className={styles.image}
            src={image[1]}
            {...imageSharedProps}
          />
        </>
      )
    }

    // Use react router <Link> when the banner link is an internal link
    if (content.link.indexOf(location.origin) > -1) {
      const internalPathOfContentLink = content.link.replace(location.origin, '')
      return (
        <Link
          onClick={() => this.onClickHandler()}
          to={internalPathOfContentLink}
          className={styles.wrapper}
        >
          { getImages() }
        </Link>
      )
    }
    // Use <a> tag when the banner link is an external url
    return (
      <a
        className={styles.wrapper}
        href={content.link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => this.onClickHandler()}
      >
        { getImages() }
      </a>
    )
  }
}

export const BannerContentType = PropTypes.shape({
  desktop: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  mobile: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  contentItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    ldId: PropTypes.string,
    isRental: PropTypes.bool,
    __typename: PropTypes.string
  })
})

Banner.propTypes = {
  content: BannerContentType.isRequired
}

export default Banner
